import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { Form } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { setBookings } from "@/slices/bookingsSlice";
import { useImperativeHandle, forwardRef, useState, useEffect } from "react";
import { SCHEMA_NAME } from "@/util/common_variable";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";

const BookingsComments = forwardRef(({ bookingsCommentsRef, startingPoint = "" }, ref) => {
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );

  const [formData, setFormData] = useState(null);

  useEffect(() => {
    if (bookings !== null) {
      setFormData({
        comments: bookings.arrestReports?.[0]?.comments ?? []
      });
    } else {
      setFormData(null);
    }
  }, [bookings]);

  useEffect(() => {
    if (formData !== null) {
      form.setFieldsValue(formData);
    } else {
      form.resetFields();
    }
  }, [formData]);

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  useImperativeHandle(bookingsCommentsRef, () => ({
    submitForm: () => form.submit(),
    resetForm: () => form.resetFields(),
    getFormValues: () => form.getFieldsValue(),
    getFieldsError: () => form.getFieldsError(),
    isFieldsValidating: () => form.isFieldsValidating(),
    validateFields: () => form.validateFields(),
  }));

  const updateForm = (data) => {
    // Update Redux state dynamically
    dispatch(
      setBookings({
        arrestReports: [
          {
            // ...bookings,
            ...bookings?.arrestReports?.[0],
            ...data,
          },
        ],
        comments: data?.comments,
      })
    );
  };

  return (
    <>
      <FieldSecurityProvider
        entity={SCHEMA_NAME.VISITOR_LOG}
        startingPoint={startingPoint}
        bookingsFieldsEnabled={bookingsFieldsEnabled}
      >
        <Form
          form={form}
          initialValues={formData}
          disabled={!bookingsFieldsEnabled}
          onBlur={() => {
            const values = bookingsCommentsRef.current.getFormValues();
            updateForm(values);
          }}
        >
          <StyledGridRow>
            <StyledGridCol span={24}>
              <SecureFormItem
                fieldName="comments"
                formItemProps={{
                  name: "comments",
                  label: "Comments",
                }}
              >
                <TextField inputType="textarea" id="Comments" />
              </SecureFormItem>
            </StyledGridCol>
          </StyledGridRow>
        </Form>
      </FieldSecurityProvider>
    </>
  );
});

export default BookingsComments;
